import { DeviceErrorLog, DeviceLogSeverity } from "../../../../../api/admin";
import {
  DSTable,
  DSTableHead,
  DSTableBody,
  DSTableRow,
  DSTableCell,
  DSTableContainer,
} from "../../../../system-design/Table";

const wrapCellSx = {
  whiteSpace: "normal" as const,
  wordBreak: "break-word" as const,
};

const formatTimestamp = (value: string) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
};

const DeviceErrorsTable = ({ data }: { data: DeviceErrorLog[] }) => (
  <DSTableContainer sx={{ maxHeight: 400, marginTop: 2, maxWidth: "100%" }}>
    <DSTable
      size="small"
      stickyHeader
      sx={{ tableLayout: "fixed", width: "100%" }}
    >
      <DSTableHead>
        <DSTableRow>
          <DSTableCell sx={{ width: 150 }}>Time</DSTableCell>
          <DSTableCell sx={{ width: 90 }}>Severity</DSTableCell>
          <DSTableCell>Message</DSTableCell>
          <DSTableCell sx={{ width: 70 }}>Version</DSTableCell>
          <DSTableCell>Exception</DSTableCell>
        </DSTableRow>
      </DSTableHead>
      <DSTableBody>
        {data.map((row, index) => (
          <DSTableRow key={index}>
            <DSTableCell sx={wrapCellSx}>
              {formatTimestamp(row.timestamp)}
            </DSTableCell>
            <DSTableCell
              sx={{
                color:
                  row.severity === DeviceLogSeverity.CRITICAL
                    ? "error.main"
                    : "warning.main",
                fontWeight: 600,
              }}
            >
              {row.severity}
            </DSTableCell>
            <DSTableCell sx={wrapCellSx}>{row.log}</DSTableCell>
            <DSTableCell>{row.version ?? "-"}</DSTableCell>
            <DSTableCell sx={wrapCellSx}>{row.exception ?? "-"}</DSTableCell>
          </DSTableRow>
        ))}
      </DSTableBody>
    </DSTable>
  </DSTableContainer>
);

export default DeviceErrorsTable;
